import React from 'react';

const TeamVideo = () => {
  return (
    <section className="w-full bg-white relative overflow-hidden">
      <div className="w-full">
        {/* Video as GIF - Full width, no controls, autoplay, loop */}
        <video 
          className="w-full h-auto block"
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
        >
          <source 
            src="https://customer-assets-jt897jd0.emergentagent.net/job_8e1f2105-ed1f-475a-a099-5d324eeb323f/artifacts/8c73234c8ff5441a_WhatsApp%20Video%202026-10-23%20at%2011.12.06.mp4" 
            type="video/mp4" 
          />
        </video>
      </div>
    </section>
  );
};

export default TeamVideo;
